import { render, staticRenderFns } from "./Basic3.vue?vue&type=template&id=621fe533&scoped=true&"
import script from "./Basic3.vue?vue&type=script&lang=js&"
export * from "./Basic3.vue?vue&type=script&lang=js&"
import style0 from "./Basic3.vue?vue&type=style&index=0&id=621fe533&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "621fe533",
  null
  
)

export default component.exports